import { Box, Typography } from '@mui/material';
import { BORDER_RADIUS, PADDING, SettingsSectionProps } from '.';
import CopyButton from '../../global/CopyButton';

export default function CopySection({
  copy,
}: {
  copy: SettingsSectionProps['copy'];
}) {
  if (!copy) return null;

  return (
    <Box
      boxSizing="border-box"
      width={{
        xs: '100%',
        sm: 'fit-content',
      }}
      maxWidth="100%"
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      gap={2}
      py={1}
      px={PADDING}
      sx={{
        borderRadius: BORDER_RADIUS,
        backgroundColor: theme => theme.palette.lightGrey.main,
      }}>
      <Typography variant="body2" noWrap flexGrow={0}>
        {copy.content}
      </Typography>
      <CopyButton content={copy.content} onCopy={copy.onCopy} />
    </Box>
  );
}
